module.exports = __webpack_public_path__ + "img/values-3.0f6fcef4.jpg";